import React, { createContext, useEffect, useReducer } from 'react'

export const SHOW_FETCH_TR_MAPPING_POPUP = 'SHOW_FETCH_TR_MAPPING_POPUP'
export const SET_TR_MAPPING_LIST = 'SET_TR_MAPPING_LIST'
export const SELECT_TRACER_MAPPING = 'SELECT_TRACER_MAPPING'
export const SET_UPDATED_TRACER_MAPPING = 'SET_UPDATED_TRACER_MAPPING'
export const SHOW_TRACER_MAPPING_POPUP = 'SHOW_TRACER_MAPPING_POPUP'

const Reducer = (data, payload) => {
  /* console.log(
    'Reducer:',
    payload.type,
    '\npayload:',
    payload,
    '\ncurrent:',
    data.selected_tracer_mapping
  ) */
  switch (payload.type) {
    case SET_TR_MAPPING_LIST: {
      return { ...data, tracer_mappings: payload.data }
    }
    case SET_UPDATED_TRACER_MAPPING: {
      let tracer_mappings = [...data.tracer_mappings]
      tracer_mappings[payload.data.index] = payload.data
      return { ...data, tracer_mappings: tracer_mappings }
    }
    case SELECT_TRACER_MAPPING: {
      return {
        ...data,
        selected_tracer_mapping: payload.data,
      }
    }
    case SHOW_FETCH_TR_MAPPING_POPUP: {
      return { ...data, show_fetch_tracer_mapping_popup: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  tracer_mappings: [],
  selected_tracer_mapping: {},
  show_fetch_tracer_mapping_popup: false,
  show_tracer_mapping_popup: false,
}

const TracerMappingStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  /* useEffect(() => {
    console.log('TracerMappingStore mounted')
  }, [])

  useEffect(() => {
    console.log('Context state changed:', state)
  }, [state]) */

  return (
    <TracerMappingContext.Provider value={[state, dispatch]}>
      {children}
    </TracerMappingContext.Provider>
  )
}

export const TracerMappingContext = createContext(initialState)
export default TracerMappingStore
